import { useState, useContext, useMemo } from 'react';
import { u as usePopper } from '../3rdPartyModules/react-popper/lib/esm/usePopper-123f9c00.js';
import { ThemeContext } from 'styled-components';
import { t as textDirectionSensitiveFn } from './popperModifiers/textDirectionSensitive-b77fc45e.js';
import { c as calculateOffsetSkidding } from './popperModifiers/calculateOffsetSkidding-8cd66dd1.js';
import { c as calculateOffsetDistance } from './popperModifiers/calculateOffsetDistance-0f292800.js';

function useInlinePopper(options) {
  var _useContext, _useContext2;
  const {
    placement,
    offsetDistance,
    offsetSkidding,
    enableFlip,
    preventOverflow,
    withArrow,
    boundaryRef,
    strategy,
    rootBoundary = 'document'
  } = options;
  const [triggerElement, setTriggerElement] = useState(null);
  const [popperElement, setPopperElement] = useState(null);
  const [arrowElement, setArrowElement] = useState(null);
  const arrowHeight = (_useContext = useContext(ThemeContext)) === null || _useContext === void 0 || (_useContext = _useContext.tooltip) === null || _useContext === void 0 ? void 0 : _useContext.arrowHeight;
  const tooltipOffset = (_useContext2 = useContext(ThemeContext)) === null || _useContext2 === void 0 || (_useContext2 = _useContext2.tooltip) === null || _useContext2 === void 0 ? void 0 : _useContext2.height;
  const offsetModifier = useMemo(() => ({
    name: 'offset',
    options: {
      offset: ({
        placement: popperPlacement
      }) => {
        const distance = calculateOffsetDistance(withArrow, arrowHeight, tooltipOffset, offsetDistance);
        const skidding = calculateOffsetSkidding(withArrow, popperPlacement, distance, offsetSkidding !== null && offsetSkidding !== void 0 ? offsetSkidding : 0);
        return [skidding, distance];
      }
    }
  }), [withArrow, arrowHeight, tooltipOffset, offsetDistance, offsetSkidding]);
  const {
    styles,
    attributes,
    update
  } = usePopper(triggerElement, popperElement, {
    placement,
    modifiers: [{
      name: 'textDirectionSensitive',
      enabled: true,
      phase: 'beforeRead',
      fn: textDirectionSensitiveFn
    }, ...(/left|right/.test(placement) ? [{
      name: 'flip',
      enabled: enableFlip,
      options: {
        rootBoundary,
        fallbackPlacements: ['bottom', 'top'],
        ...((boundaryRef === null || boundaryRef === void 0 ? void 0 : boundaryRef.current) && {
          boundary: boundaryRef.current
        })
      }
    }] : [{
      name: 'flip',
      enabled: enableFlip,
      options: {
        rootBoundary,
        ...((boundaryRef === null || boundaryRef === void 0 ? void 0 : boundaryRef.current) && {
          boundary: boundaryRef.current
        })
      }
    }]), offsetModifier, {
      name: 'arrow',
      options: {
        element: arrowElement
      }
    }, {
      name: 'preventOverflow',
      ...(preventOverflow && {
        options: {
          ...preventOverflow,
          ...((boundaryRef === null || boundaryRef === void 0 ? void 0 : boundaryRef.current) && {
            boundary: boundaryRef.current
          })
        }
      })
    }],
    strategy
  });
  return {
    styles,
    attributes,
    triggerElement,
    popperElement,
    arrowElement,
    setTriggerElement,
    setPopperElement,
    setArrowElement,
    update
  };
}

export { useInlinePopper as u };
//# sourceMappingURL=useInlinePopper-38635e23.js.map
